import axios from 'axios'

const API_BASE_URL = process.env.VUE_APP_API_URL || 'https://clubtest.intrare.app'

export const partnersRegisterAPI = {
  getInviterData (inviterToken) {
    return axios.get(
      `${API_BASE_URL}/temp-tournament-members/by-inviter-token/`,
      {
        params: { inviter_token: inviterToken }
      }
    )
  },

  addGuest (inviterToken, fullName) {
    return axios.post(
      `${API_BASE_URL}/temp-tournament-members/add-guest-by-token/`,
      {
        inviter_token: inviterToken,
        full_name: fullName
      }
    )
  }
}
